import { FunctionComponent } from 'react';
import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import useIsMobile from 'hooks/useIsMobile';
import styles from './ResetCommissionModal.module.scss';

export interface ResetCommissionModalProps {
    open: boolean;
    isResetting?: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const ResetCommissionModal: FunctionComponent<ResetCommissionModalProps> = ({
    open,
    isResetting = false,
    onClose,
    onConfirm
}) => {
    const isMobile = useIsMobile();

    if (!open) {
        return null;
    }

    return (
        <GenericModal
            onClose={isResetting ? undefined : onClose}
            className={styles.modal}
            footer={
                <div className={styles.footer}>
                    <div className={styles.left}>
                        <Button
                            size="large"
                            className={styles.button}
                            label={isMobile ? 'Cancel' : 'No'}
                            onClick={onClose}
                            variant="black"
                            disabled={isResetting}
                        />
                    </div>
                    <div className={styles.right}>
                        <Button
                            size="large"
                            className={styles.button}
                            label="Yes, reset"
                            onClick={onConfirm}
                            variant="green"
                            isLoading={isResetting}
                            disabled={isResetting}
                        />
                    </div>
                </div>
            }
        >
            <div className={styles.content}>
                <span className={styles.title}>Reset Commission?</span>
                <p className={styles.description}>
                    This will remove the manual adjustment and restore the system-calculated commission amount.
                </p>
            </div>
        </GenericModal>
    );
};

export default ResetCommissionModal;
